export default "__VITE_ASSET__B88ze_9A__"